import { createSvgComponent } from "../../icon/createSvgComponent";
import DonationFill from "@core/icon/assets/donation-fill.svg";
export default createSvgComponent(DonationFill);